<section *ngIf="validTabs.length">
	<div class="row padding-bottom-20 text-14">
		<div class="col-12"><span dcrHTMLKey="FAMILY_AS_OF" *ngIf="asOfDate">As of</span> {{ asOfDate }}</div>
		<div *ngIf="isCustomFeeEnabled" class="col-12">
			<cfe-custom-advisory-fee-dialog-button
				id="mb-custom-fee-dialog"
				[customAdvisoryFee]="customAdvisoryFee"
				[showCurrentFee]="true"
			></cfe-custom-advisory-fee-dialog-button>
		</div>
	</div>
	<section class="family-performance-table-container bordered-container no-padding text-12 text-align-right">
		<ac-combined-data-table
			[tabs]="validTabs"
			[isZebraColor]="true"
			[columnWidths]="columnWidths"
			[excludeColumns]="excludeColumns"
			[specificColumnAsHeaderY]="specificColumnAsHeaderY"
			[ignoreEmptyRow]="true"
		></ac-combined-data-table>
	</section>
</section>
